/* Use Dawn's form, availability and rendered prices as the source of truth. */
if (!customElements.get('jmcp-product-controls')) {
  customElements.define('jmcp-product-controls', class extends HTMLElement {
    connectedCallback() {
      this.product = this.closest('product-info');
      this.bar = this.querySelector('.jmcp-mobile-buy');
      this.submit = this.querySelector('[data-mobile-submit]');
      this.original = this.product.querySelector('[id^="ProductSubmitButton-"]');
      if (!this.original) return;
      // Dawn's animated/sticky product column creates a containing block for
      // fixed descendants. Keep the purchase bar attached to the viewport.
      document.body.append(this.bar);
      this.sync = this.sync.bind(this);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.product, {childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class', 'value']});
      this.product.addEventListener('change', this.sync);
      this.intersection = new IntersectionObserver(([entry]) => {
        this.bar.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      });
      this.intersection.observe(this.original);
      this.sync();
    }
    setText(selector, text) {
      const node = this.querySelector(selector) || this.bar?.querySelector(selector);
      if (node && node.textContent !== text) node.textContent = text;
    }
    sync() {
      const choices = [...this.product.querySelectorAll('variant-selects input:checked, variant-selects select')].map(input => input.value);
      const selection = choices.join(' / ');
      this.setText('[data-configuration]', selection || 'Standard configuration');
      this.setText('[data-mobile-options]', selection);
      const price = this.product.querySelector('[id^="price-"]');
      const visiblePrice = price?.querySelector('.price-item--sale') && price.querySelector('.price--on-sale')
        ? price.querySelector('.price-item--sale') : price?.querySelector('.price-item--regular');
      this.setText('[data-mobile-price]', price?.classList.contains('hidden') ? '' : visiblePrice?.textContent.trim() || '');
      const disabled = this.original.disabled;
      if (this.submit.disabled !== disabled) this.submit.disabled = disabled;
      const label = this.original.querySelector('span')?.textContent.trim() || this.original.textContent.trim();
      this.setText('[data-mobile-submit]', label);
      this.setText('[data-configuration-status]', disabled ? label : 'Ready to add to your cart');
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.intersection?.disconnect();
      this.product?.removeEventListener('change', this.sync);
      this.bar?.remove();
    }
  });
}
